import {
    BEGIN_LOGIN,
    END_LOGIN_SUCCESS,
    END_LOGIN_ERROR,
    LOGOUT,
    Authentication,
    AuthenticationActionTypes
} from "./types";

const initialState: Authentication = {
    isLoggingIn: undefined,
    error: null,
    account: undefined
};

export default (state: Authentication = initialState, action: AuthenticationActionTypes): Authentication => {
    switch (action.type) {
        case BEGIN_LOGIN:
            return { ...state, isLoggingIn: true };

        case END_LOGIN_SUCCESS:
            return { ...state, isLoggingIn: false, account: action.account };

        case END_LOGIN_ERROR:
            return { ...state, isLoggingIn: false, error: action.error };

        case LOGOUT:
            return { ...state, isLoggingIn: false };

        default:
            return state;
    }
};
